import {
	PROFILE_UPDATED,
	ADD_LOCATION,
	UPDATE_LOCATION_PLAYERS_COUNT,
	ADD_LOCATION_ERROR,
	UPDATE_CURRENT_LOCATION_COORDINATES,
} from "../actions";
import { Location, Profile } from "../types";
import { findIndex, propEq } from "ramda";

export const initialState = [] as Location[];
export type LocationsState = typeof initialState;

const AROUND_ME_PLACE_ID = "around_me";
const HOME_CITY_PLACE_ID = "home_city";

function addHomeCity(profile: Profile, locations) {
	const index = findIndex(propEq("placeId", HOME_CITY_PLACE_ID))(locations);

	if (index === -1) {
		const aroundMe = {
			name: profile.city,
			placeId: HOME_CITY_PLACE_ID,
			lat: parseFloat(profile.latitude),
			lng: parseFloat(profile.longitude),
		} as Location;

		locations.push(aroundMe);
	}
}

function addAroundMe(profile, locations) {
	const index = findIndex(propEq("placeId", AROUND_ME_PLACE_ID))(locations);

	if (index === -1) {
		const aroundMe = {
			name: "locations.aroundMe",
			placeId: AROUND_ME_PLACE_ID,
			lat: parseFloat(profile.latitude),
			lng: parseFloat(profile.longitude),
		} as Location;

		locations.push(aroundMe);
	}
}

export default function(state = initialState, action) {
	switch (action.type) {
		case PROFILE_UPDATED: {
			const locations = state;
			const profile = action.profile;

			addAroundMe(profile, locations);
			addHomeCity(profile, locations);

			return [...locations];
		}

		case ADD_LOCATION: {
			const placeId = action.location.placeId;

			const locations = state;
			const index = findIndex(propEq("placeId", placeId))(locations);
			if (index === -1) {
				locations.push(action.location);
			}

			return [...locations];
		}

		case ADD_LOCATION_ERROR: {
			const placeId = action.location.placeId;

			const locations = state;
			const index = findIndex(propEq("placeId", placeId))(locations);

			const location = locations[index] as Location;
			if (location) {
				if (action.error === null) {
					location.errorCode = null;
				} else {
					location.errorCode = action.error.code;
				}
			}
			return [...locations];
		}

		case UPDATE_CURRENT_LOCATION_COORDINATES: {
			const locations = state;
			const index = findIndex(propEq("placeId", AROUND_ME_PLACE_ID))(locations);

			const { latitude, longitude } = action;

			const location = locations[index] as Location;

			location.lat = parseFloat(latitude);
			location.lng = parseFloat(longitude);

			return [...locations];
		}

		case UPDATE_LOCATION_PLAYERS_COUNT: {
			const placeId = action.location.placeId;

			const locations = state;
			const index = findIndex(propEq("placeId", placeId))(locations);

			const location = locations[index] as Location;
			if (location) {
				location.playersCount = action.playersCount;
			}
			return [...locations];
		}

		default:
			return state;
	}
}
